import Vue from "vue";
import Vuex from "vuex";
import { Vue2Storage } from "vue2-storage";

Vue.use(Vuex);
Vue.use(Vue2Storage, {
  prefix: "parkenda_",
  driver: "local"
});

export const store = new Vuex.Store({
  state: {
    user: null,
    token: null,
    userHaveActiveParking: false,
    parkedVehicles: [],
    dropOffs: [],
    requestedVehicle: null,
    requestedDropOffId: null,
    resetPassCode: null,
    pickupLocation: null,
    lastParkingTip: null,
    requestedVehicleInfo: {},
    loyaltyVoucherUsed: false,
    totalAmount: null,
    selectedToolbalIcon: 1,
    language: "en",
    translations: {}
  },
  getters: {
    USER: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("user");
    },
    TOKEN: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("token");
    },
    USER_HAVE_ACTIVE_PARKING: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("userHaveActiveParking");
    },
    PARKED_VEHICLES: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("parkedVehicles");
    },
    RESET_PASS_CODE: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("resetPassCode");
    },
    DROP_OFFS: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("dropOffs");
    },
    REQUESTED_VEHICLE: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("requestedVehicle");
    },
    REQUESTED_DROPOFF_ID: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("requestedDropOffId");
    },
    PICKUP_LOCATION: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("pickupLocation");
    },
    LAST_PARKING_TIP: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("lastParkingTip");
    },
    REQUESTED_VEHICLE_INFO: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("requestedVehicleInfo");
    },
    LOYALTY_VOUCHER_USED: (state) => {
      store.hotUpdate(store.state);
      return state.loyaltyVoucherUsed;
    },
    TOTAL_AMOUNT: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("totalAmount");
    },
    RESIDENTS: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("residents");
    },
    RESIDENTS_TAGS: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("residentsTags");
    },
    SELECTED_RESIDENT_TAG: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("selectedResidentTag");
    },
    SELECTED_TOOLBAR_ITEM: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("selectedToolbalIcon");
    },
    SELECTED_LANGUAGE: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("language");
    },
    TRANSLATIONS: (state) => {
      store.hotUpdate(store.state);
      return Vue.$storage.get("translations");
    }
  },
  mutations: {
    SET_USER: (state, payload) => {
      // state.user = payload;
      Vue.$storage.set("user", payload);
    },
    SET_TOKEN: (state, payload) => {
      // state.token = payload;
      Vue.$storage.set("token", payload);
    },
    SET_USER_HAVE_ACTIVE_PARKING: (state, payload) => {
      // state.userHaveActiveParking = payload;
      Vue.$storage.set("userHaveActiveParking", payload);
    },
    SET_PARKED_VEHICLES: (state, payload) => {
      Vue.$storage.set("parkedVehicles", payload);
    },
    SET_RESET_PASS_CODE: (state, payload) => {
      // state.resetPassCode = payload;
      Vue.$storage.set("resetPassCode", payload);
    },
    SET_DROP_OFFS: (state, payload) => {
      // state.dropOffs = payload;
      Vue.$storage.set("dropOffs", payload);
    },
    SET_REQUESTED_VEHICLE: (state, payload) => {
      // state.requestedVehicle = payload;
      Vue.$storage.set("requestedVehicle", payload);
    },
    SET_REQUESTED_DROPOFF_ID: (state, payload) => {
      // state.requestedDropOffId = payload;
      Vue.$storage.set("requestedDropOffId", payload);
    },
    SET_PICKUP_LOCATION: (state, payload) => {
      // state.pickupLocation = payload;
      Vue.$storage.set("pickupLocation", payload);
    },
    SET_LAST_PARKING_TIP: (state, payload) => {
      // state.lastParkingTip = payload;
      Vue.$storage.set("lastParkingTip", payload);
    },
    SET_REQUESTED_VEHICLE_INFO: (state, payload) => {
      // state.requestedVehicleInfo = payload;
      Vue.$storage.set("requestedVehicleInfo", payload);
    },
    SET_LOYALTY_VOUCHER_USED: (state) => {
      state.loyaltyVoucherUsed = true;
    },
    RESET_LOYALTY_VOUCHER_USED: (state) => {
      state.loyaltyVoucherUsed = false;
    },
    SET_TOTAL_AMOUNT: (state, payload) => {
      Vue.$storage.set("totalAmount", payload);
    },
    SET_CUSTOMER_HAS_RESIDENTS: (state, payload) => {
      Vue.$storage.set("residents", payload);
    },
    SET_SELECTED_TOOLBAR_ITEM: (state, payload) => {
      Vue.$storage.set("selectedToolbalIcon", payload);
    },
    SET_LANGUAGE: (state, payload) => {
      Vue.$storage.set("language", payload);
    },
    SET_TRANSLATIONS: (state, payload) => {
      Vue.$storage.set("translations", payload);
    },
    SET_RESIDENTS_TAGS: (state, payload) => {
      Vue.$storage.set("residentsTags", payload);
    },
    SET_SELECTED_RESIDENT_TAG: (state, payload) => {
      Vue.$storage.set("selectedResidentTag", payload);
    }
  },
  actions: {
    SAVE_USER: async (context, payload) => {
      context.commit("SET_USER", payload);
    },
    SAVE_TOKEN: async (context, payload) => {
      context.commit("SET_TOKEN", payload);
    },
    SAVE_USER_HAVE_ACTIVE_PARKING: async (context, payload) => {
      context.commit("SET_USER_HAVE_ACTIVE_PARKING", payload);
    },
    SAVE_PARKED_VEHICLES: async (context, payload) => {
      context.commit("SET_PARKED_VEHICLES", payload);
    },
    SAVE_RESET_PASS_CODE: async (context, payload) => {
      context.commit("SET_RESET_PASS_CODE", payload);
    },
    SAVE_DROP_OFFS: async (context, payload) => {
      context.commit("SET_DROP_OFFS", payload);
    },
    SAVE_REQUESTED_VEHICLE: async (context, payload) => {
      context.commit("SET_REQUESTED_VEHICLE", payload);
    },
    SAVE_REQUESTED_DROPOFF_ID: async (context, payload) => {
      context.commit("SET_REQUESTED_DROPOFF_ID", payload);
    },
    SAVE_PICKUP_LOCATION: async (context, payload) => {
      context.commit("SET_PICKUP_LOCATION", payload);
    },
    SAVE_LAST_PARKING_TIP: async (context, payload) => {
      context.commit("SET_LAST_PARKING_TIP", payload);
    },
    SAVE_REQUESTED_VEHICLE_INFO: async (context, payload) => {
      context.commit("SET_REQUESTED_VEHICLE_INFO", payload);
    },
    SAVE_TOTAL_AMOUNT: async (context, payload) => {
      context.commit("SET_TOTAL_AMOUNT", payload);
    },
    SAVE_CUSTOMER_HAS_RESIDENTS: async (context, payload) => {
      context.commit("SET_CUSTOMER_HAS_RESIDENTS", payload);
    },
    LOG_OUT: () => {
      Vue.$storage.clear();
    },
    SET_LOYALTY_VOUCHER_USED: async (context) => {
      context.commit("SET_LOYALTY_VOUCHER_USED");
    },
    RESET_LOYALTY_VOUCHER_USED: async (context) => {
      context.commit("RESET_LOYALTY_VOUCHER_USED");
    },
    TOOLBAR_CLICK_ACTION: async (context, payload) => {
      context.commit("SET_SELECTED_TOOLBAR_ITEM", payload);
    },
    SET_LANGUAGE: async (context, payload) => {
      context.commit("SET_LANGUAGE", payload);
    },
    SET_TRANSLATIONS: async (context, payload) => {
      context.commit("SET_TRANSLATIONS", payload);
    },
    SET_RESIDENTS_TAGS: async (context, payload) => {
      context.commit("SET_RESIDENTS_TAGS", payload);
    },
    SET_SELECTED_RESIDENT_TAG: (context, payload) => {
      context.commit("SET_SELECTED_RESIDENT_TAG", payload);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js